/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import * as urlUtil from '@bingads-webui/url-util';
import {
  RecommendationService,
  RecommendationDownloadService,
  withGetSummary,
  CHANNEL_TYPES,
  withRecommendationsScope as withScope,
  withCoupon,
} from '@bingads-webui-campaign/recommendation-core';
import { withCcJsData } from '@bingads-webui-cc-react/js-data-rest';
import { schema } from './instrumentation-schema';
import { RecommendationTab } from './recommendation-tab';
import { withNavigation } from './with-navigation';

const RecommendationTabWithData = withGetSummary(false)(withCoupon(RecommendationTab));

class RecommendationTabContainerView extends React.Component {
  static propTypes = {
    scope: PropTypes.shape({
      customerId: PropTypes.number,
      accountId: PropTypes.number,
      levelAt: PropTypes.string,
    }),
    showAlertHandler: PropTypes.func,
    deps: PropTypes.shape({
      appConfig: PropTypes.objectOf(PropTypes.any).isRequired,
      appState: PropTypes.object.isRequired,
      i18n: PropTypes.object.isRequired,
      s$i18n: PropTypes.object,
      instrumentation: PropTypes.object.isRequired,
      jsdata: PropTypes.object.isRequired,
      legacyRouter: PropTypes.object.isRequired,
      pageContext: PropTypes.object.isRequired,
      permissions: PropTypes.object.isRequired,
      preferencesService: PropTypes.objectOf(PropTypes.any).isRequired,
      constants: PropTypes.shape({
        imagePath: PropTypes.string.isRequired,
      }).isRequired,
      combineText: PropTypes.func.isRequired,
      adDisplayUrlService: PropTypes.object.isRequired,
      odata: PropTypes.PropTypes.shape({
        get: PropTypes.func.isRequired,
        patch: PropTypes.func.isRequired,
      }).isRequired,
      schemaCampaignVnext: PropTypes.object,
      validator: PropTypes.object,
    }).isRequired,
    guid: PropTypes.string, // for adinsight view event log in aria
    viewType: PropTypes.string,
    ccJsData: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    vnextDeps: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  };

  static defaultProps = {
    scope: null,
    showAlertHandler: _.noop,
    guid: null,
    viewType: null,
    ccJsData: null,
    vnextDeps: null,
  };

  constructor(props) {
    super(props);
    this.initializeInstrumentation();
    // don't initialize if scope is not set
    if (this.props.scope != null) {
      this.initializeDataService();
      this.initializeDownloadService();
    }
  }
  initializeDownloadService() {
    const {
      pageContext,
      i18n,
      odata,
    } = this.props.deps;
    const { permissions } = this.props.deps;
    this.downloadService = null;
    this.downloadService = new RecommendationDownloadService({
      alertCenter: window.App.views.alertCenter,
      getODataErrors: _.noop,
      i18n,
      odata,
      pageContext,
      permissions,
      currentActivity: this.currentActivity,
    });
  }

  initializeInstrumentation() {
    const { instrumentation } = this.props.deps;
    instrumentation.addScenario(schema);
    this.currentScenario = instrumentation.loadRecommendationTab.create();
    this.currentActivity = this.currentScenario.loadRecommendationTab.create();
  }

  initializeDataService() {
    const {
      appConfig,
      permissions,
      pageContext,
      i18n,
    } = this.props.deps;
    const odataPath = appConfig.get('adinsight.odata.url');
    this.dataService = new RecommendationService({
      scope: this.props.scope,
      showAlertHandler: this.props.showAlertHandler,
      i18n,
      currentScenario: this.currentScenario,
      currentActivity: this.currentActivity,
      odataPath,
      permissions,
      lcid: pageContext.CultureLcid,
      pageContext,
      ccJsData: this.props.ccJsData || (this.props.vnextDeps && this.props.vnextDeps.ccJsData),
      alertCenter: window.App.views.alertCenter,
      channel: CHANNEL_TYPES.RECOMMENDATION,
    });
  }

  render() {
    const { appConfig, pageContext } = this.props.deps;
    const source = appConfig.get('recsrc') || urlUtil.getParameter('recsrc');

    // clean 'recsrc' after get the viewType, because sometimes this render() function will run
    // twice, so if clean the 'recsrc' at 1st time, we can't get 'recsrc' anymore
    if (this.props.viewType) {
      appConfig.set('recsrc', null);
    }

    return (
      <div className="recommendations-container" railviewid="Recommendations_Summary" >
        {this.props.scope && <RecommendationTabWithData
          {...this.props}
          dataService={this.dataService}
          downloadService={this.downloadService}
          currentActivity={this.currentActivity}
          channel={CHANNEL_TYPES.RECOMMENDATION}
          source={source}
          serverContext={pageContext}
        />}
      </div>
    );
  }
}

export const RecommendationTabContainer =
  withCcJsData(withScope(withNavigation(RecommendationTabContainerView)));
